const present = value => value !== undefined && value !== null && value !== '';

// Empty availability alone cannot prove that a required resource is optional.
// Only explicit resource-less catalog metadata permits removing hidden values.
export const normalizeAppointmentResourceSelection = (values = {}) => {
  if (!values || typeof values !== 'object' || Array.isArray(values)) return values;
  const noResource = values.resource_required === false
    && values.resource_id !== undefined && !present(values.resource_id)
    && !present(values.service?.resource_id)
    && !values.resource_requirements?.length && !values.service?.resource_requirements?.length;
  const result = noResource
    ? {...values, resource_item_id:'', resource_allocations:[]}
    : {...values};
  for (const field of ['addonservices','addanotherservices']) {
    if (Array.isArray(values[field])) result[field] = values[field].map(normalizeAppointmentResourceSelection);
  }
  return result;
};
